
export const country = [
    {
      "name": "Ascension Island",
      "code": "AC",
      "emoji": "🇦🇨",
      "unicode": "U+1F1E6 U+1F1E8",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AC.svg"
    },
    {
      "name": "Andorra",
      "code": "AD",
      "emoji": "🇦🇩",
      "unicode": "U+1F1E6 U+1F1E9",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AD.svg"
    },
    {
      "name": "United Arab Emirates",
      "code": "AE",
      "emoji": "🇦🇪",
      "unicode": "U+1F1E6 U+1F1EA",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AE.svg"
    },
    {
      "name": "Afghanistan",
      "code": "AF",
      "emoji": "🇦🇫",
      "unicode": "U+1F1E6 U+1F1EB",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AF.svg"
    },
    {
      "name": "Antigua & Barbuda",
      "code": "AG",
      "emoji": "🇦🇬",
      "unicode": "U+1F1E6 U+1F1EC",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AG.svg"
    },
    {
      "name": "Anguilla",
      "code": "AI",
      "emoji": "🇦🇮",
      "unicode": "U+1F1E6 U+1F1EE",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AI.svg"
    },
    {
      "name": "Albania",
      "code": "AL",
      "emoji": "🇦🇱",
      "unicode": "U+1F1E6 U+1F1F1",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AL.svg"
    },
    {
      "name": "Armenia",
      "code": "AM",
      "emoji": "🇦🇲",
      "unicode": "U+1F1E6 U+1F1F2",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AM.svg"
    },
    {
      "name": "Angola",
      "code": "AO",
      "emoji": "🇦🇴",
      "unicode": "U+1F1E6 U+1F1F4",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AO.svg"
    },
    {
      "name": "Antarctica",
      "code": "AQ",
      "emoji": "🇦🇶",
      "unicode": "U+1F1E6 U+1F1F6",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AQ.svg"
    },
    {
      "name": "Argentina",
      "code": "AR",
      "emoji": "🇦🇷",
      "unicode": "U+1F1E6 U+1F1F7",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AR.svg"
    },
    {
      "name": "American Samoa",
      "code": "AS",
      "emoji": "🇦🇸",
      "unicode": "U+1F1E6 U+1F1F8",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AS.svg"
    },
    {
      "name": "Austria",
      "code": "AT",
      "emoji": "🇦🇹",
      "unicode": "U+1F1E6 U+1F1F9",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AT.svg"
    },
    {
      "name": "Australia",
      "code": "AU",
      "emoji": "🇦🇺",
      "unicode": "U+1F1E6 U+1F1FA",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AU.svg"
    },
    {
      "name": "Aruba",
      "code": "AW",
      "emoji": "🇦🇼",
      "unicode": "U+1F1E6 U+1F1FC",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AW.svg"
    },
    {
      "name": "Åland Islands",
      "code": "AX",
      "emoji": "🇦🇽",
      "unicode": "U+1F1E6 U+1F1FD",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AX.svg"
    },
    {
      "name": "Azerbaijan",
      "code": "AZ",
      "emoji": "🇦🇿",
      "unicode": "U+1F1E6 U+1F1FF",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AZ.svg"
    },
    {
      "name": "Bosnia & Herzegovina",
      "code": "BA",
      "emoji": "🇧🇦",
      "unicode": "U+1F1E7 U+1F1E6",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BA.svg"
    },
    {
      "name": "Barbados",
      "code": "BB",
      "emoji": "🇧🇧",
      "unicode": "U+1F1E7 U+1F1E7",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BB.svg"
    },
    {
      "name": "Bangladesh",
      "code": "BD",
      "emoji": "🇧🇩",
      "unicode": "U+1F1E7 U+1F1E9",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BD.svg"
    },
    {
      "name": "Belgium",
      "code": "BE",
      "emoji": "🇧🇪",
      "unicode": "U+1F1E7 U+1F1EA",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BE.svg"
    },
    {
      "name": "Burkina Faso",
      "code": "BF",
      "emoji": "🇧🇫",
      "unicode": "U+1F1E7 U+1F1EB",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BF.svg"
    },
    {
      "name": "Bulgaria",
      "code": "BG",
      "emoji": "🇧🇬",
      "unicode": "U+1F1E7 U+1F1EC",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BG.svg"
    },
    {
      "name": "Bahrain",
      "code": "BH",
      "emoji": "🇧🇭",
      "unicode": "U+1F1E7 U+1F1ED",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BH.svg"
    },
    {
      "name": "Burundi",
      "code": "BI",
      "emoji": "🇧🇮",
      "unicode": "U+1F1E7 U+1F1EE",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BI.svg"
    },
    {
      "name": "Benin",
      "code": "BJ",
      "emoji": "🇧🇯",
      "unicode": "U+1F1E7 U+1F1EF",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BJ.svg"
    },
    {
      "name": "St. Barthélemy",
      "code": "BL",
      "emoji": "🇧🇱",
      "unicode": "U+1F1E7 U+1F1F1",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BL.svg"
    },
    {
      "name": "Bermuda",
      "code": "BM",
      "emoji": "🇧🇲",
      "unicode": "U+1F1E7 U+1F1F2",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BM.svg"
    },
    {
      "name": "Brunei",
      "code": "BN",
      "emoji": "🇧🇳",
      "unicode": "U+1F1E7 U+1F1F3",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BN.svg"
    },
    {
      "name": "Bolivia",
      "code": "BO",
      "emoji": "🇧🇴",
      "unicode": "U+1F1E7 U+1F1F4",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BO.svg"
    },
    {
      "name": "Caribbean Netherlands",
      "code": "BQ",
      "emoji": "🇧🇶",
      "unicode": "U+1F1E7 U+1F1F6",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BQ.svg"
    },
    {
      "name": "Brazil",
      "code": "BR",
      "emoji": "🇧🇷",
      "unicode": "U+1F1E7 U+1F1F7",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BR.svg"
    },
    {
      "name": "Bahamas",
      "code": "BS",
      "emoji": "🇧🇸",
      "unicode": "U+1F1E7 U+1F1F8",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BS.svg"
    },
    {
      "name": "Bhutan",
      "code": "BT",
      "emoji": "🇧🇹",
      "unicode": "U+1F1E7 U+1F1F9",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BT.svg"
    },
    {
      "name": "Bouvet Island",
      "code": "BV",
      "emoji": "🇧🇻",
      "unicode": "U+1F1E7 U+1F1FB",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BV.svg"
    },
    {
      "name": "Botswana",
      "code": "BW",
      "emoji": "🇧🇼",
      "unicode": "U+1F1E7 U+1F1FC",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BW.svg"
    },
    {
      "name": "Belarus",
      "code": "BY",
      "emoji": "🇧🇾",
      "unicode": "U+1F1E7 U+1F1FE",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BY.svg"
    },
    {
      "name": "Belize",
      "code": "BZ",
      "emoji": "🇧🇿",
      "unicode": "U+1F1E7 U+1F1FF",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BZ.svg"
    },
    {
      "name": "Canada",
      "code": "CA",
      "emoji": "🇨🇦",
      "unicode": "U+1F1E8 U+1F1E6",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CA.svg"
    },
    {
      "name": "Cocos (Keeling) Islands",
      "code": "CC",
      "emoji": "🇨🇨",
      "unicode": "U+1F1E8 U+1F1E8",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CC.svg"
    },
    {
      "name": "Congo - Kinshasa",
      "code": "CD",
      "emoji": "🇨🇩",
      "unicode": "U+1F1E8 U+1F1E9",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CD.svg"
    },
    {
      "name": "Central African Republic",
      "code": "CF",
      "emoji": "🇨🇫",
      "unicode": "U+1F1E8 U+1F1EB",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CF.svg"
    },
    {
      "name": "Congo - Brazzaville",
      "code": "CG",
      "emoji": "🇨🇬",
      "unicode": "U+1F1E8 U+1F1EC",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CG.svg"
    },
    {
      "name": "Switzerland",
      "code": "CH",
      "emoji": "🇨🇭",
      "unicode": "U+1F1E8 U+1F1ED",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CH.svg"
    },
    {
      "name": "Côte d’Ivoire",
      "code": "CI",
      "emoji": "🇨🇮",
      "unicode": "U+1F1E8 U+1F1EE",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CI.svg"
    },
    {
      "name": "Cook Islands",
      "code": "CK",
      "emoji": "🇨🇰",
      "unicode": "U+1F1E8 U+1F1F0",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CK.svg"
    },
    {
      "name": "Chile",
      "code": "CL",
      "emoji": "🇨🇱",
      "unicode": "U+1F1E8 U+1F1F1",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CL.svg"
    },
    {
      "name": "Cameroon",
      "code": "CM",
      "emoji": "🇨🇲",
      "unicode": "U+1F1E8 U+1F1F2",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CM.svg"
    },
    {
      "name": "China",
      "code": "CN",
      "emoji": "🇨🇳",
      "unicode": "U+1F1E8 U+1F1F3",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CN.svg"
    },
    {
      "name": "Colombia",
      "code": "CO",
      "emoji": "🇨🇴",
      "unicode": "U+1F1E8 U+1F1F4",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CO.svg"
    },
    {
      "name": "Clipperton Island",
      "code": "CP",
      "emoji": "🇨🇵",
      "unicode": "U+1F1E8 U+1F1F5",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CP.svg"
    },
    {
      "name": "Costa Rica",
      "code": "CR",
      "emoji": "🇨🇷",
      "unicode": "U+1F1E8 U+1F1F7",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CR.svg"
    },
    {
      "name": "Cuba",
      "code": "CU",
      "emoji": "🇨🇺",
      "unicode": "U+1F1E8 U+1F1FA",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CU.svg"
    },
    {
      "name": "Cape Verde",
      "code": "CV",
      "emoji": "🇨🇻",
      "unicode": "U+1F1E8 U+1F1FB",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CV.svg"
    },
    {
      "name": "Curaçao",
      "code": "CW",
      "emoji": "🇨🇼",
      "unicode": "U+1F1E8 U+1F1FC",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CW.svg"
    },
    {
      "name": "Christmas Island",
      "code": "CX",
      "emoji": "🇨🇽",
      "unicode": "U+1F1E8 U+1F1FD",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CX.svg"
    },
    {
      "name": "Cyprus",
      "code": "CY",
      "emoji": "🇨🇾",
      "unicode": "U+1F1E8 U+1F1FE",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CY.svg"
    },
    {
      "name": "Czechia",
      "code": "CZ",
      "emoji": "🇨🇿",
      "unicode": "U+1F1E8 U+1F1FF",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CZ.svg"
    },
    {
      "name": "Germany",
      "code": "DE",
      "emoji": "🇩🇪",
      "unicode": "U+1F1E9 U+1F1EA",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DE.svg"
    },
    {
      "name": "Diego Garcia",
      "code": "DG",
      "emoji": "🇩🇬",
      "unicode": "U+1F1E9 U+1F1EC",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DG.svg"
    },
    {
      "name": "Djibouti",
      "code": "DJ",
      "emoji": "🇩🇯",
      "unicode": "U+1F1E9 U+1F1EF",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DJ.svg"
    },
    {
      "name": "Denmark",
      "code": "DK",
      "emoji": "🇩🇰",
      "unicode": "U+1F1E9 U+1F1F0",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DK.svg"
    },
    {
      "name": "Dominica",
      "code": "DM",
      "emoji": "🇩🇲",
      "unicode": "U+1F1E9 U+1F1F2",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DM.svg"
    },
    {
      "name": "Dominican Republic",
      "code": "DO",
      "emoji": "🇩🇴",
      "unicode": "U+1F1E9 U+1F1F4",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DO.svg"
    },
    {
      "name": "Algeria",
      "code": "DZ",
      "emoji": "🇩🇿",
      "unicode": "U+1F1E9 U+1F1FF",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DZ.svg"
    },
    {
      "name": "Ceuta & Melilla",
      "code": "EA",
      "emoji": "🇪🇦",
      "unicode": "U+1F1EA U+1F1E6",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/EA.svg"
    },
    {
      "name": "Ecuador",
      "code": "EC",
      "emoji": "🇪🇨",
      "unicode": "U+1F1EA U+1F1E8",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/EC.svg"
    },
    {
      "name": "Estonia",
      "code": "EE",
      "emoji": "🇪🇪",
      "unicode": "U+1F1EA U+1F1EA",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/EE.svg"
    },
    {
      "name": "Egypt",
      "code": "EG",
      "emoji": "🇪🇬",
      "unicode": "U+1F1EA U+1F1EC",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/EG.svg"
    },
    {
      "name": "Western Sahara",
      "code": "EH",
      "emoji": "🇪🇭",
      "unicode": "U+1F1EA U+1F1ED",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/EH.svg"
    },
    {
      "name": "Eritrea",
      "code": "ER",
      "emoji": "🇪🇷",
      "unicode": "U+1F1EA U+1F1F7",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ER.svg"
    },
    {
      "name": "Spain",
      "code": "ES",
      "emoji": "🇪🇸",
      "unicode": "U+1F1EA U+1F1F8",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ES.svg"
    },
    {
      "name": "Ethiopia",
      "code": "ET",
      "emoji": "🇪🇹",
      "unicode": "U+1F1EA U+1F1F9",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ET.svg"
    },
    {
      "name": "European Union",
      "code": "EU",
      "emoji": "🇪🇺",
      "unicode": "U+1F1EA U+1F1FA",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/EU.svg"
    },
    {
      "name": "Finland",
      "code": "FI",
      "emoji": "🇫🇮",
      "unicode": "U+1F1EB U+1F1EE",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FI.svg"
    },
    {
      "name": "Fiji",
      "code": "FJ",
      "emoji": "🇫🇯",
      "unicode": "U+1F1EB U+1F1EF",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FJ.svg"
    },
    {
      "name": "Falkland Islands",
      "code": "FK",
      "emoji": "🇫🇰",
      "unicode": "U+1F1EB U+1F1F0",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FK.svg"
    },
    {
      "name": "Micronesia",
      "code": "FM",
      "emoji": "🇫🇲",
      "unicode": "U+1F1EB U+1F1F2",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FM.svg"
    },
    {
      "name": "Faroe Islands",
      "code": "FO",
      "emoji": "🇫🇴",
      "unicode": "U+1F1EB U+1F1F4",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FO.svg"
    },
    {
      "name": "France",
      "code": "FR",
      "emoji": "🇫🇷",
      "unicode": "U+1F1EB U+1F1F7",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FR.svg"
    },
    {
      "name": "Gabon",
      "code": "GA",
      "emoji": "🇬🇦",
      "unicode": "U+1F1EC U+1F1E6",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GA.svg"
    },
    {
      "name": "United Kingdom",
      "code": "GB",
      "emoji": "🇬🇧",
      "unicode": "U+1F1EC U+1F1E7",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GB.svg"
    },
    {
      "name": "Grenada",
      "code": "GD",
      "emoji": "🇬🇩",
      "unicode": "U+1F1EC U+1F1E9",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GD.svg"
    },
    {
      "name": "Georgia",
      "code": "GE",
      "emoji": "🇬🇪",
      "unicode": "U+1F1EC U+1F1EA",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GE.svg"
    },
    {
      "name": "French Guiana",
      "code": "GF",
      "emoji": "🇬🇫",
      "unicode": "U+1F1EC U+1F1EB",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GF.svg"
    },
    {
      "name": "Guernsey",
      "code": "GG",
      "emoji": "🇬🇬",
      "unicode": "U+1F1EC U+1F1EC",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GG.svg"
    },
    {
      "name": "Ghana",
      "code": "GH",
      "emoji": "🇬🇭",
      "unicode": "U+1F1EC U+1F1ED",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GH.svg"
    },
    {
      "name": "Gibraltar",
      "code": "GI",
      "emoji": "🇬🇮",
      "unicode": "U+1F1EC U+1F1EE",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GI.svg"
    },
    {
      "name": "Greenland",
      "code": "GL",
      "emoji": "🇬🇱",
      "unicode": "U+1F1EC U+1F1F1",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GL.svg"
    },
    {
      "name": "Gambia",
      "code": "GM",
      "emoji": "🇬🇲",
      "unicode": "U+1F1EC U+1F1F2",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GM.svg"
    },
    {
      "name": "Guinea",
      "code": "GN",
      "emoji": "🇬🇳",
      "unicode": "U+1F1EC U+1F1F3",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GN.svg"
    },
    {
      "name": "Guadeloupe",
      "code": "GP",
      "emoji": "🇬🇵",
      "unicode": "U+1F1EC U+1F1F5",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GP.svg"
    },
    {
      "name": "Equatorial Guinea",
      "code": "GQ",
      "emoji": "🇬🇶",
      "unicode": "U+1F1EC U+1F1F6",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GQ.svg"
    },
    {
      "name": "Greece",
      "code": "GR",
      "emoji": "🇬🇷",
      "unicode": "U+1F1EC U+1F1F7",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GR.svg"
    },
    {
      "name": "South Georgia & South Sandwich Islands",
      "code": "GS",
      "emoji": "🇬🇸",
      "unicode": "U+1F1EC U+1F1F8",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GS.svg"
    },
    {
      "name": "Guatemala",
      "code": "GT",
      "emoji": "🇬🇹",
      "unicode": "U+1F1EC U+1F1F9",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GT.svg"
    },
    {
      "name": "Guam",
      "code": "GU",
      "emoji": "🇬🇺",
      "unicode": "U+1F1EC U+1F1FA",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GU.svg"
    },
    {
      "name": "Guinea-Bissau",
      "code": "GW",
      "emoji": "🇬🇼",
      "unicode": "U+1F1EC U+1F1FC",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GW.svg"
    },
    {
      "name": "Guyana",
      "code": "GY",
      "emoji": "🇬🇾",
      "unicode": "U+1F1EC U+1F1FE",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GY.svg"
    },
    {
      "name": "Hong Kong SAR China",
      "code": "HK",
      "emoji": "🇭🇰",
      "unicode": "U+1F1ED U+1F1F0",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/HK.svg"
    },
    {
      "name": "Heard & McDonald Islands",
      "code": "HM",
      "emoji": "🇭🇲",
      "unicode": "U+1F1ED U+1F1F2",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/HM.svg"
    },
    {
      "name": "Honduras",
      "code": "HN",
      "emoji": "🇭🇳",
      "unicode": "U+1F1ED U+1F1F3",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/HN.svg"
    },
    {
      "name": "Croatia",
      "code": "HR",
      "emoji": "🇭🇷",
      "unicode": "U+1F1ED U+1F1F7",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/HR.svg"
    },
    {
      "name": "Haiti",
      "code": "HT",
      "emoji": "🇭🇹",
      "unicode": "U+1F1ED U+1F1F9",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/HT.svg"
    },
    {
      "name": "Hungary",
      "code": "HU",
      "emoji": "🇭🇺",
      "unicode": "U+1F1ED U+1F1FA",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/HU.svg"
    },
    {
      "name": "Canary Islands",
      "code": "IC",
      "emoji": "🇮🇨",
      "unicode": "U+1F1EE U+1F1E8",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IC.svg"
    },
    {
      "name": "Indonesia",
      "code": "ID",
      "emoji": "🇮🇩",
      "unicode": "U+1F1EE U+1F1E9",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ID.svg"
    },
    {
      "name": "Ireland",
      "code": "IE",
      "emoji": "🇮🇪",
      "unicode": "U+1F1EE U+1F1EA",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IE.svg"
    },
    {
      "name": "Israel",
      "code": "IL",
      "emoji": "🇮🇱",
      "unicode": "U+1F1EE U+1F1F1",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IL.svg"
    },
    {
      "name": "Isle of Man",
      "code": "IM",
      "emoji": "🇮🇲",
      "unicode": "U+1F1EE U+1F1F2",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IM.svg"
    },
    {
      "name": "India",
      "code": "IN",
      "emoji": "🇮🇳",
      "unicode": "U+1F1EE U+1F1F3",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IN.svg"
    },
    {
      "name": "British Indian Ocean Territory",
      "code": "IO",
      "emoji": "🇮🇴",
      "unicode": "U+1F1EE U+1F1F4",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IO.svg"
    },
    {
      "name": "Iraq",
      "code": "IQ",
      "emoji": "🇮🇶",
      "unicode": "U+1F1EE U+1F1F6",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IQ.svg"
    },
    {
      "name": "Iran",
      "code": "IR",
      "emoji": "🇮🇷",
      "unicode": "U+1F1EE U+1F1F7",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IR.svg"
    },
    {
      "name": "Iceland",
      "code": "IS",
      "emoji": "🇮🇸",
      "unicode": "U+1F1EE U+1F1F8",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IS.svg"
    },
    {
      "name": "Italy",
      "code": "IT",
      "emoji": "🇮🇹",
      "unicode": "U+1F1EE U+1F1F9",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IT.svg"
    },
    {
      "name": "Jersey",
      "code": "JE",
      "emoji": "🇯🇪",
      "unicode": "U+1F1EF U+1F1EA",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/JE.svg"
    },
    {
      "name": "Jamaica",
      "code": "JM",
      "emoji": "🇯🇲",
      "unicode": "U+1F1EF U+1F1F2",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/JM.svg"
    },
    {
      "name": "Jordan",
      "code": "JO",
      "emoji": "🇯🇴",
      "unicode": "U+1F1EF U+1F1F4",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/JO.svg"
    },
    {
      "name": "Japan",
      "code": "JP",
      "emoji": "🇯🇵",
      "unicode": "U+1F1EF U+1F1F5",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/JP.svg"
    },
    {
      "name": "Kenya",
      "code": "KE",
      "emoji": "🇰🇪",
      "unicode": "U+1F1F0 U+1F1EA",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KE.svg"
    },
    {
      "name": "Kyrgyzstan",
      "code": "KG",
      "emoji": "🇰🇬",
      "unicode": "U+1F1F0 U+1F1EC",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KG.svg"
    },
    {
      "name": "Cambodia",
      "code": "KH",
      "emoji": "🇰🇭",
      "unicode": "U+1F1F0 U+1F1ED",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KH.svg"
    },
    {
      "name": "Kiribati",
      "code": "KI",
      "emoji": "🇰🇮",
      "unicode": "U+1F1F0 U+1F1EE",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KI.svg"
    },
    {
      "name": "Comoros",
      "code": "KM",
      "emoji": "🇰🇲",
      "unicode": "U+1F1F0 U+1F1F2",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KM.svg"
    },
    {
      "name": "St. Kitts & Nevis",
      "code": "KN",
      "emoji": "🇰🇳",
      "unicode": "U+1F1F0 U+1F1F3",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KN.svg"
    },
    {
      "name": "North Korea",
      "code": "KP",
      "emoji": "🇰🇵",
      "unicode": "U+1F1F0 U+1F1F5",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KP.svg"
    },
    {
      "name": "South Korea",
      "code": "KR",
      "emoji": "🇰🇷",
      "unicode": "U+1F1F0 U+1F1F7",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KR.svg"
    },
    {
      "name": "Kuwait",
      "code": "KW",
      "emoji": "🇰🇼",
      "unicode": "U+1F1F0 U+1F1FC",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KW.svg"
    },
    {
      "name": "Cayman Islands",
      "code": "KY",
      "emoji": "🇰🇾",
      "unicode": "U+1F1F0 U+1F1FE",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KY.svg"
    },
    {
      "name": "Kazakhstan",
      "code": "KZ",
      "emoji": "🇰🇿",
      "unicode": "U+1F1F0 U+1F1FF",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KZ.svg"
    },
    {
      "name": "Laos",
      "code": "LA",
      "emoji": "🇱🇦",
      "unicode": "U+1F1F1 U+1F1E6",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LA.svg"
    },
    {
      "name": "Lebanon",
      "code": "LB",
      "emoji": "🇱🇧",
      "unicode": "U+1F1F1 U+1F1E7",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LB.svg"
    },
    {
      "name": "St. Lucia",
      "code": "LC",
      "emoji": "🇱🇨",
      "unicode": "U+1F1F1 U+1F1E8",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LC.svg"
    },
    {
      "name": "Liechtenstein",
      "code": "LI",
      "emoji": "🇱🇮",
      "unicode": "U+1F1F1 U+1F1EE",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LI.svg"
    },
    {
      "name": "Sri Lanka",
      "code": "LK",
      "emoji": "🇱🇰",
      "unicode": "U+1F1F1 U+1F1F0",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LK.svg"
    },
    {
      "name": "Liberia",
      "code": "LR",
      "emoji": "🇱🇷",
      "unicode": "U+1F1F1 U+1F1F7",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LR.svg"
    },
    {
      "name": "Lesotho",
      "code": "LS",
      "emoji": "🇱🇸",
      "unicode": "U+1F1F1 U+1F1F8",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LS.svg"
    },
    {
      "name": "Lithuania",
      "code": "LT",
      "emoji": "🇱🇹",
      "unicode": "U+1F1F1 U+1F1F9",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LT.svg"
    },
    {
      "name": "Luxembourg",
      "code": "LU",
      "emoji": "🇱🇺",
      "unicode": "U+1F1F1 U+1F1FA",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LU.svg"
    },
    {
      "name": "Latvia",
      "code": "LV",
      "emoji": "🇱🇻",
      "unicode": "U+1F1F1 U+1F1FB",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LV.svg"
    },
    {
      "name": "Libya",
      "code": "LY",
      "emoji": "🇱🇾",
      "unicode": "U+1F1F1 U+1F1FE",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LY.svg"
    },
    {
      "name": "Morocco",
      "code": "MA",
      "emoji": "🇲🇦",
      "unicode": "U+1F1F2 U+1F1E6",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MA.svg"
    },
    {
      "name": "Monaco",
      "code": "MC",
      "emoji": "🇲🇨",
      "unicode": "U+1F1F2 U+1F1E8",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MC.svg"
    },
    {
      "name": "Moldova",
      "code": "MD",
      "emoji": "🇲🇩",
      "unicode": "U+1F1F2 U+1F1E9",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MD.svg"
    },
    {
      "name": "Montenegro",
      "code": "ME",
      "emoji": "🇲🇪",
      "unicode": "U+1F1F2 U+1F1EA",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ME.svg"
    },
    {
      "name": "St. Martin",
      "code": "MF",
      "emoji": "🇲🇫",
      "unicode": "U+1F1F2 U+1F1EB",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MF.svg"
    },
    {
      "name": "Madagascar",
      "code": "MG",
      "emoji": "🇲🇬",
      "unicode": "U+1F1F2 U+1F1EC",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MG.svg"
    },
    {
      "name": "Marshall Islands",
      "code": "MH",
      "emoji": "🇲🇭",
      "unicode": "U+1F1F2 U+1F1ED",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MH.svg"
    },
    {
      "name": "North Macedonia",
      "code": "MK",
      "emoji": "🇲🇰",
      "unicode": "U+1F1F2 U+1F1F0",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MK.svg"
    },
    {
      "name": "Mali",
      "code": "ML",
      "emoji": "🇲🇱",
      "unicode": "U+1F1F2 U+1F1F1",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ML.svg"
    },
    {
      "name": "Myanmar (Burma)",
      "code": "MM",
      "emoji": "🇲🇲",
      "unicode": "U+1F1F2 U+1F1F2",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MM.svg"
    },
    {
      "name": "Mongolia",
      "code": "MN",
      "emoji": "🇲🇳",
      "unicode": "U+1F1F2 U+1F1F3",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MN.svg"
    },
    {
      "name": "Macao SAR China",
      "code": "MO",
      "emoji": "🇲🇴",
      "unicode": "U+1F1F2 U+1F1F4",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MO.svg"
    },
    {
      "name": "Northern Mariana Islands",
      "code": "MP",
      "emoji": "🇲🇵",
      "unicode": "U+1F1F2 U+1F1F5",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MP.svg"
    },
    {
      "name": "Martinique",
      "code": "MQ",
      "emoji": "🇲🇶",
      "unicode": "U+1F1F2 U+1F1F6",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MQ.svg"
    },
    {
      "name": "Mauritania",
      "code": "MR",
      "emoji": "🇲🇷",
      "unicode": "U+1F1F2 U+1F1F7",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MR.svg"
    },
    {
      "name": "Montserrat",
      "code": "MS",
      "emoji": "🇲🇸",
      "unicode": "U+1F1F2 U+1F1F8",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MS.svg"
    },
    {
      "name": "Malta",
      "code": "MT",
      "emoji": "🇲🇹",
      "unicode": "U+1F1F2 U+1F1F9",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MT.svg"
    },
    {
      "name": "Mauritius",
      "code": "MU",
      "emoji": "🇲🇺",
      "unicode": "U+1F1F2 U+1F1FA",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MU.svg"
    },
    {
      "name": "Maldives",
      "code": "MV",
      "emoji": "🇲🇻",
      "unicode": "U+1F1F2 U+1F1FB",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MV.svg"
    },
    {
      "name": "Malawi",
      "code": "MW",
      "emoji": "🇲🇼",
      "unicode": "U+1F1F2 U+1F1FC",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MW.svg"
    },
    {
      "name": "Mexico",
      "code": "MX",
      "emoji": "🇲🇽",
      "unicode": "U+1F1F2 U+1F1FD",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MX.svg"
    },
    {
      "name": "Malaysia",
      "code": "MY",
      "emoji": "🇲🇾",
      "unicode": "U+1F1F2 U+1F1FE",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MY.svg"
    },
    {
      "name": "Mozambique",
      "code": "MZ",
      "emoji": "🇲🇿",
      "unicode": "U+1F1F2 U+1F1FF",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MZ.svg"
    },
    {
      "name": "Namibia",
      "code": "NA",
      "emoji": "🇳🇦",
      "unicode": "U+1F1F3 U+1F1E6",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NA.svg"
    },
    {
      "name": "New Caledonia",
      "code": "NC",
      "emoji": "🇳🇨",
      "unicode": "U+1F1F3 U+1F1E8",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NC.svg"
    },
    {
      "name": "Niger",
      "code": "NE",
      "emoji": "🇳🇪",
      "unicode": "U+1F1F3 U+1F1EA",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NE.svg"
    },
    {
      "name": "Norfolk Island",
      "code": "NF",
      "emoji": "🇳🇫",
      "unicode": "U+1F1F3 U+1F1EB",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NF.svg"
    },
    {
      "name": "Nigeria",
      "code": "NG",
      "emoji": "🇳🇬",
      "unicode": "U+1F1F3 U+1F1EC",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NG.svg"
    },
    {
      "name": "Nicaragua",
      "code": "NI",
      "emoji": "🇳🇮",
      "unicode": "U+1F1F3 U+1F1EE",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NI.svg"
    },
    {
      "name": "Netherlands",
      "code": "NL",
      "emoji": "🇳🇱",
      "unicode": "U+1F1F3 U+1F1F1",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NL.svg"
    },
    {
      "name": "Norway",
      "code": "NO",
      "emoji": "🇳🇴",
      "unicode": "U+1F1F3 U+1F1F4",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NO.svg"
    },
    {
      "name": "Nepal",
      "code": "NP",
      "emoji": "🇳🇵",
      "unicode": "U+1F1F3 U+1F1F5",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NP.svg"
    },
    {
      "name": "Nauru",
      "code": "NR",
      "emoji": "🇳🇷",
      "unicode": "U+1F1F3 U+1F1F7",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NR.svg"
    },
    {
      "name": "Niue",
      "code": "NU",
      "emoji": "🇳🇺",
      "unicode": "U+1F1F3 U+1F1FA",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NU.svg"
    },
    {
      "name": "New Zealand",
      "code": "NZ",
      "emoji": "🇳🇿",
      "unicode": "U+1F1F3 U+1F1FF",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NZ.svg"
    },
    {
      "name": "Oman",
      "code": "OM",
      "emoji": "🇴🇲",
      "unicode": "U+1F1F4 U+1F1F2",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/OM.svg"
    },
    {
      "name": "Panama",
      "code": "PA",
      "emoji": "🇵🇦",
      "unicode": "U+1F1F5 U+1F1E6",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PA.svg"
    },
    {
      "name": "Peru",
      "code": "PE",
      "emoji": "🇵🇪",
      "unicode": "U+1F1F5 U+1F1EA",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PE.svg"
    },
    {
      "name": "French Polynesia",
      "code": "PF",
      "emoji": "🇵🇫",
      "unicode": "U+1F1F5 U+1F1EB",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PF.svg"
    },
    {
      "name": "Papua New Guinea",
      "code": "PG",
      "emoji": "🇵🇬",
      "unicode": "U+1F1F5 U+1F1EC",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PG.svg"
    },
    {
      "name": "Philippines",
      "code": "PH",
      "emoji": "🇵🇭",
      "unicode": "U+1F1F5 U+1F1ED",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PH.svg"
    },
    {
      "name": "Pakistan",
      "code": "PK",
      "emoji": "🇵🇰",
      "unicode": "U+1F1F5 U+1F1F0",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PK.svg"
    },
    {
      "name": "Poland",
      "code": "PL",
      "emoji": "🇵🇱",
      "unicode": "U+1F1F5 U+1F1F1",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PL.svg"
    },
    {
      "name": "St. Pierre & Miquelon",
      "code": "PM",
      "emoji": "🇵🇲",
      "unicode": "U+1F1F5 U+1F1F2",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PM.svg"
    },
    {
      "name": "Pitcairn Islands",
      "code": "PN",
      "emoji": "🇵🇳",
      "unicode": "U+1F1F5 U+1F1F3",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PN.svg"
    },
    {
      "name": "Puerto Rico",
      "code": "PR",
      "emoji": "🇵🇷",
      "unicode": "U+1F1F5 U+1F1F7",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PR.svg"
    },
    {
      "name": "Palestinian Territories",
      "code": "PS",
      "emoji": "🇵🇸",
      "unicode": "U+1F1F5 U+1F1F8",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PS.svg"
    },
    {
      "name": "Portugal",
      "code": "PT",
      "emoji": "🇵🇹",
      "unicode": "U+1F1F5 U+1F1F9",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PT.svg"
    },
    {
      "name": "Palau",
      "code": "PW",
      "emoji": "🇵🇼",
      "unicode": "U+1F1F5 U+1F1FC",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PW.svg"
    },
    {
      "name": "Paraguay",
      "code": "PY",
      "emoji": "🇵🇾",
      "unicode": "U+1F1F5 U+1F1FE",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PY.svg"
    },
    {
      "name": "Qatar",
      "code": "QA",
      "emoji": "🇶🇦",
      "unicode": "U+1F1F6 U+1F1E6",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/QA.svg"
    },
    {
      "name": "Réunion",
      "code": "RE",
      "emoji": "🇷🇪",
      "unicode": "U+1F1F7 U+1F1EA",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/RE.svg"
    },
    {
      "name": "Romania",
      "code": "RO",
      "emoji": "🇷🇴",
      "unicode": "U+1F1F7 U+1F1F4",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/RO.svg"
    },
    {
      "name": "Serbia",
      "code": "RS",
      "emoji": "🇷🇸",
      "unicode": "U+1F1F7 U+1F1F8",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/RS.svg"
    },
    {
      "name": "Russia",
      "code": "RU",
      "emoji": "🇷🇺",
      "unicode": "U+1F1F7 U+1F1FA",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/RU.svg"
    },
    {
      "name": "Rwanda",
      "code": "RW",
      "emoji": "🇷🇼",
      "unicode": "U+1F1F7 U+1F1FC",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/RW.svg"
    },
    {
      "name": "Saudi Arabia",
      "code": "SA",
      "emoji": "🇸🇦",
      "unicode": "U+1F1F8 U+1F1E6",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SA.svg"
    },
    {
      "name": "Solomon Islands",
      "code": "SB",
      "emoji": "🇸🇧",
      "unicode": "U+1F1F8 U+1F1E7",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SB.svg"
    },
    {
      "name": "Seychelles",
      "code": "SC",
      "emoji": "🇸🇨",
      "unicode": "U+1F1F8 U+1F1E8",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SC.svg"
    },
    {
      "name": "Sudan",
      "code": "SD",
      "emoji": "🇸🇩",
      "unicode": "U+1F1F8 U+1F1E9",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SD.svg"
    },
    {
      "name": "Sweden",
      "code": "SE",
      "emoji": "🇸🇪",
      "unicode": "U+1F1F8 U+1F1EA",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SE.svg"
    },
    {
      "name": "Singapore",
      "code": "SG",
      "emoji": "🇸🇬",
      "unicode": "U+1F1F8 U+1F1EC",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SG.svg"
    },
    {
      "name": "St. Helena",
      "code": "SH",
      "emoji": "🇸🇭",
      "unicode": "U+1F1F8 U+1F1ED",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SH.svg"
    },
    {
      "name": "Slovenia",
      "code": "SI",
      "emoji": "🇸🇮",
      "unicode": "U+1F1F8 U+1F1EE",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SI.svg"
    },
    {
      "name": "Svalbard & Jan Mayen",
      "code": "SJ",
      "emoji": "🇸🇯",
      "unicode": "U+1F1F8 U+1F1EF",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SJ.svg"
    },
    {
      "name": "Slovakia",
      "code": "SK",
      "emoji": "🇸🇰",
      "unicode": "U+1F1F8 U+1F1F0",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SK.svg"
    },
    {
      "name": "Sierra Leone",
      "code": "SL",
      "emoji": "🇸🇱",
      "unicode": "U+1F1F8 U+1F1F1",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SL.svg"
    },
    {
      "name": "San Marino",
      "code": "SM",
      "emoji": "🇸🇲",
      "unicode": "U+1F1F8 U+1F1F2",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SM.svg"
    },
    {
      "name": "Senegal",
      "code": "SN",
      "emoji": "🇸🇳",
      "unicode": "U+1F1F8 U+1F1F3",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SN.svg"
    },
    {
      "name": "Somalia",
      "code": "SO",
      "emoji": "🇸🇴",
      "unicode": "U+1F1F8 U+1F1F4",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SO.svg"
    },
    {
      "name": "Suriname",
      "code": "SR",
      "emoji": "🇸🇷",
      "unicode": "U+1F1F8 U+1F1F7",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SR.svg"
    },
    {
      "name": "South Sudan",
      "code": "SS",
      "emoji": "🇸🇸",
      "unicode": "U+1F1F8 U+1F1F8",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SS.svg"
    },
    {
      "name": "São Tomé & Príncipe",
      "code": "ST",
      "emoji": "🇸🇹",
      "unicode": "U+1F1F8 U+1F1F9",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ST.svg"
    },
    {
      "name": "El Salvador",
      "code": "SV",
      "emoji": "🇸🇻",
      "unicode": "U+1F1F8 U+1F1FB",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SV.svg"
    },
    {
      "name": "Sint Maarten",
      "code": "SX",
      "emoji": "🇸🇽",
      "unicode": "U+1F1F8 U+1F1FD",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SX.svg"
    },
    {
      "name": "Syria",
      "code": "SY",
      "emoji": "🇸🇾",
      "unicode": "U+1F1F8 U+1F1FE",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SY.svg"
    },
    {
      "name": "Eswatini",
      "code": "SZ",
      "emoji": "🇸🇿",
      "unicode": "U+1F1F8 U+1F1FF",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SZ.svg"
    },
    {
      "name": "Tristan da Cunha",
      "code": "TA",
      "emoji": "🇹🇦",
      "unicode": "U+1F1F9 U+1F1E6",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TA.svg"
    },
    {
      "name": "Turks & Caicos Islands",
      "code": "TC",
      "emoji": "🇹🇨",
      "unicode": "U+1F1F9 U+1F1E8",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TC.svg"
    },
    {
      "name": "Chad",
      "code": "TD",
      "emoji": "🇹🇩",
      "unicode": "U+1F1F9 U+1F1E9",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TD.svg"
    },
    {
      "name": "French Southern Territories",
      "code": "TF",
      "emoji": "🇹🇫",
      "unicode": "U+1F1F9 U+1F1EB",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TF.svg"
    },
    {
      "name": "Togo",
      "code": "TG",
      "emoji": "🇹🇬",
      "unicode": "U+1F1F9 U+1F1EC",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TG.svg"
    },
    {
      "name": "Thailand",
      "code": "TH",
      "emoji": "🇹🇭",
      "unicode": "U+1F1F9 U+1F1ED",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TH.svg"
    },
    {
      "name": "Tajikistan",
      "code": "TJ",
      "emoji": "🇹🇯",
      "unicode": "U+1F1F9 U+1F1EF",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TJ.svg"
    },
    {
      "name": "Tokelau",
      "code": "TK",
      "emoji": "🇹🇰",
      "unicode": "U+1F1F9 U+1F1F0",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TK.svg"
    },
    {
      "name": "Timor-Leste",
      "code": "TL",
      "emoji": "🇹🇱",
      "unicode": "U+1F1F9 U+1F1F1",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TL.svg"
    },
    {
      "name": "Turkmenistan",
      "code": "TM",
      "emoji": "🇹🇲",
      "unicode": "U+1F1F9 U+1F1F2",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TM.svg"
    },
    {
      "name": "Tunisia",
      "code": "TN",
      "emoji": "🇹🇳",
      "unicode": "U+1F1F9 U+1F1F3",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TN.svg"
    },
    {
      "name": "Tonga",
      "code": "TO",
      "emoji": "🇹🇴",
      "unicode": "U+1F1F9 U+1F1F4",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TO.svg"
    },
    {
      "name": "Turkey",
      "code": "TR",
      "emoji": "🇹🇷",
      "unicode": "U+1F1F9 U+1F1F7",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TR.svg"
    },
    {
      "name": "Trinidad & Tobago",
      "code": "TT",
      "emoji": "🇹🇹",
      "unicode": "U+1F1F9 U+1F1F9",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TT.svg"
    },
    {
      "name": "Tuvalu",
      "code": "TV",
      "emoji": "🇹🇻",
      "unicode": "U+1F1F9 U+1F1FB",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TV.svg"
    },
    {
      "name": "Taiwan",
      "code": "TW",
      "emoji": "🇹🇼",
      "unicode": "U+1F1F9 U+1F1FC",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TW.svg"
    },
    {
      "name": "Tanzania",
      "code": "TZ",
      "emoji": "🇹🇿",
      "unicode": "U+1F1F9 U+1F1FF",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TZ.svg"
    },
    {
      "name": "Ukraine",
      "code": "UA",
      "emoji": "🇺🇦",
      "unicode": "U+1F1FA U+1F1E6",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/UA.svg"
    },
    {
      "name": "Uganda",
      "code": "UG",
      "emoji": "🇺🇬",
      "unicode": "U+1F1FA U+1F1EC",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/UG.svg"
    },
    {
      "name": "U.S. Outlying Islands",
      "code": "UM",
      "emoji": "🇺🇲",
      "unicode": "U+1F1FA U+1F1F2",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/UM.svg"
    },
    {
      "name": "United Nations",
      "code": "UN",
      "emoji": "🇺🇳",
      "unicode": "U+1F1FA U+1F1F3",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/UN.svg"
    },
    {
      "name": "United States",
      "code": "US",
      "emoji": "🇺🇸",
      "unicode": "U+1F1FA U+1F1F8",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/US.svg"
    },
    {
      "name": "Uruguay",
      "code": "UY",
      "emoji": "🇺🇾",
      "unicode": "U+1F1FA U+1F1FE",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/UY.svg"
    },
    {
      "name": "Uzbekistan",
      "code": "UZ",
      "emoji": "🇺🇿",
      "unicode": "U+1F1FA U+1F1FF",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/UZ.svg"
    },
    {
      "name": "Vatican City",
      "code": "VA",
      "emoji": "🇻🇦",
      "unicode": "U+1F1FB U+1F1E6",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VA.svg"
    },
    {
      "name": "St. Vincent & Grenadines",
      "code": "VC",
      "emoji": "🇻🇨",
      "unicode": "U+1F1FB U+1F1E8",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VC.svg"
    },
    {
      "name": "Venezuela",
      "code": "VE",
      "emoji": "🇻🇪",
      "unicode": "U+1F1FB U+1F1EA",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VE.svg"
    },
    {
      "name": "British Virgin Islands",
      "code": "VG",
      "emoji": "🇻🇬",
      "unicode": "U+1F1FB U+1F1EC",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VG.svg"
    },
    {
      "name": "U.S. Virgin Islands",
      "code": "VI",
      "emoji": "🇻🇮",
      "unicode": "U+1F1FB U+1F1EE",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VI.svg"
    },
    {
      "name": "Vietnam",
      "code": "VN",
      "emoji": "🇻🇳",
      "unicode": "U+1F1FB U+1F1F3",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VN.svg"
    },
    {
      "name": "Vanuatu",
      "code": "VU",
      "emoji": "🇻🇺",
      "unicode": "U+1F1FB U+1F1FA",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VU.svg"
    },
    {
      "name": "Wallis & Futuna",
      "code": "WF",
      "emoji": "🇼🇫",
      "unicode": "U+1F1FC U+1F1EB",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/WF.svg"
    },
    {
      "name": "Samoa",
      "code": "WS",
      "emoji": "🇼🇸",
      "unicode": "U+1F1FC U+1F1F8",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/WS.svg"
    },
    {
      "name": "Kosovo",
      "code": "XK",
      "emoji": "🇽🇰",
      "unicode": "U+1F1FD U+1F1F0",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/XK.svg"
    },
    {
      "name": "Yemen",
      "code": "YE",
      "emoji": "🇾🇪",
      "unicode": "U+1F1FE U+1F1EA",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/YE.svg"
    },
    {
      "name": "Mayotte",
      "code": "YT",
      "emoji": "🇾🇹",
      "unicode": "U+1F1FE U+1F1F9",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/YT.svg"
    },
    {
      "name": "South Africa",
      "code": "ZA",
      "emoji": "🇿🇦",
      "unicode": "U+1F1FF U+1F1E6",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ZA.svg"
    },
    {
      "name": "Zambia",
      "code": "ZM",
      "emoji": "🇿🇲",
      "unicode": "U+1F1FF U+1F1F2",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ZM.svg"
    },
    {
      "name": "Zimbabwe",
      "code": "ZW",
      "emoji": "🇿🇼",
      "unicode": "U+1F1FF U+1F1FC",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ZW.svg"
    },
    {
      "name": "England",
      "code": "ENGLAND",
      "emoji": "🏴󠁧󠁢󠁥󠁮󠁧󠁿",
      "unicode": "U+1F3F4 U+E0067 U+E0062 U+E0065 U+E006E U+E0067 U+E007F",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ENGLAND.svg"
    },
    {
      "name": "Scotland",
      "code": "SCOTLAND",
      "emoji": "🏴󠁧󠁢󠁳󠁣󠁴󠁿",
      "unicode": "U+1F3F4 U+E0067 U+E0062 U+E0073 U+E0063 U+E0074 U+E007F",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SCOTLAND.svg"
    },
    {
      "name": "Wales",
      "code": "WALES",
      "emoji": "🏴󠁧󠁢󠁷󠁬󠁳󠁿",
      "unicode": "U+1F3F4 U+E0067 U+E0062 U+E0077 U+E006C U+E0073 U+E007F",
      "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/WALES.svg"
    }
  ]
export const country1 = [
    {
    "name": "Afghanistan",
    "dial_code": "+93",
    "code": "AF"
    },
    {
    "name": "Aland Islands",
    "dial_code": "+358",
    "code": "AX"
    },
    {
    "name": "Albania",
    "dial_code": "+355",
    "code": "AL"
    },
    {
    "name": "Algeria",
    "dial_code": "+213",
    "code": "DZ"
    },
    {
    "name": "AmericanSamoa",
    "dial_code": "+1684",
    "code": "AS"
    },
    {
    "name": "Andorra",
    "dial_code": "+376",
    "code": "AD"
    },
    {
    "name": "Angola",
    "dial_code": "+244",
    "code": "AO"
    },
    {
    "name": "Anguilla",
    "dial_code": "+1264",
    "code": "AI"
    },
    {
    "name": "Antarctica",
    "dial_code": "+672",
    "code": "AQ"
    },
    {
    "name": "Antigua and Barbuda",
    "dial_code": "+1268",
    "code": "AG"
    },
    {
    "name": "Argentina",
    "dial_code": "+54",
    "code": "AR"
    },
    {
    "name": "Armenia",
    "dial_code": "+374",
    "code": "AM"
    },
    {
    "name": "Aruba",
    "dial_code": "+297",
    "code": "AW"
    },
    {
    "name": "Australia",
    "dial_code": "+61",
    "code": "AU"
    },
    {
    "name": "Austria",
    "dial_code": "+43",
    "code": "AT"
    },
    {
    "name": "Azerbaijan",
    "dial_code": "+994",
    "code": "AZ"
    },
    {
    "name": "Bahamas",
    "dial_code": "+1242",
    "code": "BS"
    },
    {
    "name": "Bahrain",
    "dial_code": "+973",
    "code": "BH"
    },
    {
    "name": "Bangladesh",
    "dial_code": "+880",
    "code": "BD"
    },
    {
    "name": "Barbados",
    "dial_code": "+1246",
    "code": "BB"
    },
    {
    "name": "Belarus",
    "dial_code": "+375",
    "code": "BY"
    },
    {
    "name": "Belgium",
    "dial_code": "+32",
    "code": "BE"
    },
    {
    "name": "Belize",
    "dial_code": "+501",
    "code": "BZ"
    },
    {
    "name": "Benin",
    "dial_code": "+229",
    "code": "BJ"
    },
    {
    "name": "Bermuda",
    "dial_code": "+1441",
    "code": "BM"
    },
    {
    "name": "Bhutan",
    "dial_code": "+975",
    "code": "BT"
    },
    {
    "name": "Bolivia, Plurinational State of",
    "dial_code": "+591",
    "code": "BO"
    },
    {
    "name": "Bosnia and Herzegovina",
    "dial_code": "+387",
    "code": "BA"
    },
    {
    "name": "Botswana",
    "dial_code": "+267",
    "code": "BW"
    },
    {
    "name": "Brazil",
    "dial_code": "+55",
    "code": "BR"
    },
    {
    "name": "British Indian Ocean Territory",
    "dial_code": "+246",
    "code": "IO"
    },
    {
    "name": "Brunei Darussalam",
    "dial_code": "+673",
    "code": "BN"
    },
    {
    "name": "Bulgaria",
    "dial_code": "+359",
    "code": "BG"
    },
    {
    "name": "Burkina Faso",
    "dial_code": "+226",
    "code": "BF"
    },
    {
    "name": "Burundi",
    "dial_code": "+257",
    "code": "BI"
    },
    {
    "name": "Cambodia",
    "dial_code": "+855",
    "code": "KH"
    },
    {
    "name": "Cameroon",
    "dial_code": "+237",
    "code": "CM"
    },
    {
    "name": "Canada",
    "dial_code": "+1",
    "code": "CA"
    },
    {
    "name": "Cape Verde",
    "dial_code": "+238",
    "code": "CV"
    },
    {
    "name": "Cayman Islands",
    "dial_code": "+ 345",
    "code": "KY"
    },
    {
    "name": "Central African Republic",
    "dial_code": "+236",
    "code": "CF"
    },
    {
    "name": "Chad",
    "dial_code": "+235",
    "code": "TD"
    },
    {
    "name": "Chile",
    "dial_code": "+56",
    "code": "CL"
    },
    {
    "name": "China",
    "dial_code": "+86",
    "code": "CN"
    },
    {
    "name": "Christmas Island",
    "dial_code": "+61",
    "code": "CX"
    },
    {
    "name": "Cocos (Keeling) Islands",
    "dial_code": "+61",
    "code": "CC"
    },
    {
    "name": "Colombia",
    "dial_code": "+57",
    "code": "CO"
    },
    {
    "name": "Comoros",
    "dial_code": "+269",
    "code": "KM"
    },
    {
    "name": "Congo",
    "dial_code": "+242",
    "code": "CG"
    },
    {
    "name": "Congo, The Democratic Republic of the Congo",
    "dial_code": "+243",
    "code": "CD"
    },
    {
    "name": "Cook Islands",
    "dial_code": "+682",
    "code": "CK"
    },
    {
    "name": "Costa Rica",
    "dial_code": "+506",
    "code": "CR"
    },
    {
    "name": "Cote d'Ivoire",
    "dial_code": "+225",
    "code": "CI"
    },
    {
    "name": "Croatia",
    "dial_code": "+385",
    "code": "HR"
    },
    {
    "name": "Cuba",
    "dial_code": "+53",
    "code": "CU"
    },
    {
    "name": "Cyprus",
    "dial_code": "+357",
    "code": "CY"
    },
    {
    "name": "Czech Republic",
    "dial_code": "+420",
    "code": "CZ"
    },
    {
    "name": "Denmark",
    "dial_code": "+45",
    "code": "DK"
    },
    {
    "name": "Djibouti",
    "dial_code": "+253",
    "code": "DJ"
    },
    {
    "name": "Dominica",
    "dial_code": "+1767",
    "code": "DM"
    },
    {
    "name": "Dominican Republic",
    "dial_code": "+1849",
    "code": "DO"
    },
    {
    "name": "Ecuador",
    "dial_code": "+593",
    "code": "EC"
    },
    {
    "name": "Egypt",
    "dial_code": "+20",
    "code": "EG"
    },
    {
    "name": "El Salvador",
    "dial_code": "+503",
    "code": "SV"
    },
    {
    "name": "Equatorial Guinea",
    "dial_code": "+240",
    "code": "GQ"
    },
    {
    "name": "Eritrea",
    "dial_code": "+291",
    "code": "ER"
    },
    {
    "name": "Estonia",
    "dial_code": "+372",
    "code": "EE"
    },
    {
    "name": "Ethiopia",
    "dial_code": "+251",
    "code": "ET"
    },
    {
    "name": "Falkland Islands (Malvinas)",
    "dial_code": "+500",
    "code": "FK"
    },
    {
    "name": "Faroe Islands",
    "dial_code": "+298",
    "code": "FO"
    },
    {
    "name": "Fiji",
    "dial_code": "+679",
    "code": "FJ"
    },
    {
    "name": "Finland",
    "dial_code": "+358",
    "code": "FI"
    },
    {
    "name": "France",
    "dial_code": "+33",
    "code": "FR"
    },
    {
    "name": "French Guiana",
    "dial_code": "+594",
    "code": "GF"
    },
    {
    "name": "French Polynesia",
    "dial_code": "+689",
    "code": "PF"
    },
    {
    "name": "Gabon",
    "dial_code": "+241",
    "code": "GA"
    },
    {
    "name": "Gambia",
    "dial_code": "+220",
    "code": "GM"
    },
    {
    "name": "Georgia",
    "dial_code": "+995",
    "code": "GE"
    },
    {
    "name": "Germany",
    "dial_code": "+49",
    "code": "DE"
    },
    {
    "name": "Ghana",
    "dial_code": "+233",
    "code": "GH"
    },
    {
    "name": "Gibraltar",
    "dial_code": "+350",
    "code": "GI"
    },
    {
    "name": "Greece",
    "dial_code": "+30",
    "code": "GR"
    },
    {
    "name": "Greenland",
    "dial_code": "+299",
    "code": "GL"
    },
    {
    "name": "Grenada",
    "dial_code": "+1473",
    "code": "GD"
    },
    {
    "name": "Guadeloupe",
    "dial_code": "+590",
    "code": "GP"
    },
    {
    "name": "Guam",
    "dial_code": "+1671",
    "code": "GU"
    },
    {
    "name": "Guatemala",
    "dial_code": "+502",
    "code": "GT"
    },
    {
    "name": "Guernsey",
    "dial_code": "+44",
    "code": "GG"
    },
    {
    "name": "Guinea",
    "dial_code": "+224",
    "code": "GN"
    },
    {
    "name": "Guinea-Bissau",
    "dial_code": "+245",
    "code": "GW"
    },
    {
    "name": "Guyana",
    "dial_code": "+595",
    "code": "GY"
    },
    {
    "name": "Haiti",
    "dial_code": "+509",
    "code": "HT"
    },
    {
    "name": "Holy See (Vatican City State)",
    "dial_code": "+379",
    "code": "VA"
    },
    {
    "name": "Honduras",
    "dial_code": "+504",
    "code": "HN"
    },
    {
    "name": "Hong Kong",
    "dial_code": "+852",
    "code": "HK"
    },
    {
    "name": "Hungary",
    "dial_code": "+36",
    "code": "HU"
    },
    {
    "name": "Iceland",
    "dial_code": "+354",
    "code": "IS"
    },
    {
    "name": "India",
    "dial_code": "+91",
    "code": "IN"
    },
    {
    "name": "Indonesia",
    "dial_code": "+62",
    "code": "ID"
    },
    {
    "name": "Iran, Islamic Republic of Persian Gulf",
    "dial_code": "+98",
    "code": "IR"
    },
    {
    "name": "Iraq",
    "dial_code": "+964",
    "code": "IQ"
    },
    {
    "name": "Ireland",
    "dial_code": "+353",
    "code": "IE"
    },
    {
    "name": "Isle of Man",
    "dial_code": "+44",
    "code": "IM"
    },
    {
    "name": "Israel",
    "dial_code": "+972",
    "code": "IL"
    },
    {
    "name": "Italy",
    "dial_code": "+39",
    "code": "IT"
    },
    {
    "name": "Jamaica",
    "dial_code": "+1876",
    "code": "JM"
    },
    {
    "name": "Japan",
    "dial_code": "+81",
    "code": "JP"
    },
    {
    "name": "Jersey",
    "dial_code": "+44",
    "code": "JE"
    },
    {
    "name": "Jordan",
    "dial_code": "+962",
    "code": "JO"
    },
    {
    "name": "Kazakhstan",
    "dial_code": "+77",
    "code": "KZ"
    },
    {
    "name": "Kenya",
    "dial_code": "+254",
    "code": "KE"
    },
    {
    "name": "Kiribati",
    "dial_code": "+686",
    "code": "KI"
    },
    {
    "name": "Korea, Democratic People's Republic of Korea",
    "dial_code": "+850",
    "code": "KP"
    },
    {
    "name": "Korea, Republic of South Korea",
    "dial_code": "+82",
    "code": "KR"
    },
    {
    "name": "Kuwait",
    "dial_code": "+965",
    "code": "KW"
    },
    {
    "name": "Kyrgyzstan",
    "dial_code": "+996",
    "code": "KG"
    },
    {
    "name": "Laos",
    "dial_code": "+856",
    "code": "LA"
    },
    {
    "name": "Latvia",
    "dial_code": "+371",
    "code": "LV"
    },
    {
    "name": "Lebanon",
    "dial_code": "+961",
    "code": "LB"
    },
    {
    "name": "Lesotho",
    "dial_code": "+266",
    "code": "LS"
    },
    {
    "name": "Liberia",
    "dial_code": "+231",
    "code": "LR"
    },
    {
    "name": "Libyan Arab Jamahiriya",
    "dial_code": "+218",
    "code": "LY"
    },
    {
    "name": "Liechtenstein",
    "dial_code": "+423",
    "code": "LI"
    },
    {
    "name": "Lithuania",
    "dial_code": "+370",
    "code": "LT"
    },
    {
    "name": "Luxembourg",
    "dial_code": "+352",
    "code": "LU"
    },
    {
    "name": "Macao",
    "dial_code": "+853",
    "code": "MO"
    },
    {
    "name": "Macedonia",
    "dial_code": "+389",
    "code": "MK"
    },
    {
    "name": "Madagascar",
    "dial_code": "+261",
    "code": "MG"
    },
    {
    "name": "Malawi",
    "dial_code": "+265",
    "code": "MW"
    },
    {
    "name": "Malaysia",
    "dial_code": "+60",
    "code": "MY"
    },
    {
    "name": "Maldives",
    "dial_code": "+960",
    "code": "MV"
    },
    {
    "name": "Mali",
    "dial_code": "+223",
    "code": "ML"
    },
    {
    "name": "Malta",
    "dial_code": "+356",
    "code": "MT"
    },
    {
    "name": "Marshall Islands",
    "dial_code": "+692",
    "code": "MH"
    },
    {
    "name": "Martinique",
    "dial_code": "+596",
    "code": "MQ"
    },
    {
    "name": "Mauritania",
    "dial_code": "+222",
    "code": "MR"
    },
    {
    "name": "Mauritius",
    "dial_code": "+230",
    "code": "MU"
    },
    {
    "name": "Mayotte",
    "dial_code": "+262",
    "code": "YT"
    },
    {
    "name": "Mexico",
    "dial_code": "+52",
    "code": "MX"
    },
    {
    "name": "Micronesia, Federated States of Micronesia",
    "dial_code": "+691",
    "code": "FM"
    },
    {
    "name": "Moldova",
    "dial_code": "+373",
    "code": "MD"
    },
    {
    "name": "Monaco",
    "dial_code": "+377",
    "code": "MC"
    },
    {
    "name": "Mongolia",
    "dial_code": "+976",
    "code": "MN"
    },
    {
    "name": "Montenegro",
    "dial_code": "+382",
    "code": "ME"
    },
    {
    "name": "Montserrat",
    "dial_code": "+1664",
    "code": "MS"
    },
    {
    "name": "Morocco",
    "dial_code": "+212",
    "code": "MA"
    },
    {
    "name": "Mozambique",
    "dial_code": "+258",
    "code": "MZ"
    },
    {
    "name": "Myanmar",
    "dial_code": "+95",
    "code": "MM"
    },
    {
    "name": "Namibia",
    "dial_code": "+264",
    "code": "NA"
    },
    {
    "name": "Nauru",
    "dial_code": "+674",
    "code": "NR"
    },
    {
    "name": "Nepal",
    "dial_code": "+977",
    "code": "NP"
    },
    {
    "name": "Netherlands",
    "dial_code": "+31",
    "code": "NL"
    },
    {
    "name": "Netherlands Antilles",
    "dial_code": "+599",
    "code": "AN"
    },
    {
    "name": "New Caledonia",
    "dial_code": "+687",
    "code": "NC"
    },
    {
    "name": "New Zealand",
    "dial_code": "+64",
    "code": "NZ"
    },
    {
    "name": "Nicaragua",
    "dial_code": "+505",
    "code": "NI"
    },
    {
    "name": "Niger",
    "dial_code": "+227",
    "code": "NE"
    },
    {
    "name": "Nigeria",
    "dial_code": "+234",
    "code": "NG"
    },
    {
    "name": "Niue",
    "dial_code": "+683",
    "code": "NU"
    },
    {
    "name": "Norfolk Island",
    "dial_code": "+672",
    "code": "NF"
    },
    {
    "name": "Northern Mariana Islands",
    "dial_code": "+1670",
    "code": "MP"
    },
    {
    "name": "Norway",
    "dial_code": "+47",
    "code": "NO"
    },
    {
    "name": "Oman",
    "dial_code": "+968",
    "code": "OM"
    },
    {
    "name": "Pakistan",
    "dial_code": "+92",
    "code": "PK"
    },
    {
    "name": "Palau",
    "dial_code": "+680",
    "code": "PW"
    },
    {
    "name": "Palestinian Territory, Occupied",
    "dial_code": "+970",
    "code": "PS"
    },
    {
    "name": "Panama",
    "dial_code": "+507",
    "code": "PA"
    },
    {
    "name": "Papua New Guinea",
    "dial_code": "+675",
    "code": "PG"
    },
    {
    "name": "Paraguay",
    "dial_code": "+595",
    "code": "PY"
    },
    {
    "name": "Peru",
    "dial_code": "+51",
    "code": "PE"
    },
    {
    "name": "Philippines",
    "dial_code": "+63",
    "code": "PH"
    },
    {
    "name": "Pitcairn",
    "dial_code": "+872",
    "code": "PN"
    },
    {
    "name": "Poland",
    "dial_code": "+48",
    "code": "PL"
    },
    {
    "name": "Portugal",
    "dial_code": "+351",
    "code": "PT"
    },
    {
    "name": "Puerto Rico",
    "dial_code": "+1939",
    "code": "PR"
    },
    {
    "name": "Qatar",
    "dial_code": "+974",
    "code": "QA"
    },
    {
    "name": "Romania",
    "dial_code": "+40",
    "code": "RO"
    },
    {
    "name": "Russia",
    "dial_code": "+7",
    "code": "RU"
    },
    {
    "name": "Rwanda",
    "dial_code": "+250",
    "code": "RW"
    },
    {
    "name": "Reunion",
    "dial_code": "+262",
    "code": "RE"
    },
    {
    "name": "Saint Barthelemy",
    "dial_code": "+590",
    "code": "BL"
    },
    {
    "name": "Saint Helena, Ascension and Tristan Da Cunha",
    "dial_code": "+290",
    "code": "SH"
    },
    {
    "name": "Saint Kitts and Nevis",
    "dial_code": "+1869",
    "code": "KN"
    },
    {
    "name": "Saint Lucia",
    "dial_code": "+1758",
    "code": "LC"
    },
    {
    "name": "Saint Martin",
    "dial_code": "+590",
    "code": "MF"
    },
    {
    "name": "Saint Pierre and Miquelon",
    "dial_code": "+508",
    "code": "PM"
    },
    {
    "name": "Saint Vincent and the Grenadines",
    "dial_code": "+1784",
    "code": "VC"
    },
    {
    "name": "Samoa",
    "dial_code": "+685",
    "code": "WS"
    },
    {
    "name": "San Marino",
    "dial_code": "+378",
    "code": "SM"
    },
    {
    "name": "Sao Tome and Principe",
    "dial_code": "+239",
    "code": "ST"
    },
    {
    "name": "Saudi Arabia",
    "dial_code": "+966",
    "code": "SA"
    },
    {
    "name": "Senegal",
    "dial_code": "+221",
    "code": "SN"
    },
    {
    "name": "Serbia",
    "dial_code": "+381",
    "code": "RS"
    },
    {
    "name": "Seychelles",
    "dial_code": "+248",
    "code": "SC"
    },
    {
    "name": "Sierra Leone",
    "dial_code": "+232",
    "code": "SL"
    },
    {
    "name": "Singapore",
    "dial_code": "+65",
    "code": "SG"
    },
    {
    "name": "Slovakia",
    "dial_code": "+421",
    "code": "SK"
    },
    {
    "name": "Slovenia",
    "dial_code": "+386",
    "code": "SI"
    },
    {
    "name": "Solomon Islands",
    "dial_code": "+677",
    "code": "SB"
    },
    {
    "name": "Somalia",
    "dial_code": "+252",
    "code": "SO"
    },
    {
    "name": "South Africa",
    "dial_code": "+27",
    "code": "ZA"
    },
    {
    "name": "South Sudan",
    "dial_code": "+211",
    "code": "SS"
    },
    {
    "name": "South Georgia and the South Sandwich Islands",
    "dial_code": "+500",
    "code": "GS"
    },
    {
    "name": "Spain",
    "dial_code": "+34",
    "code": "ES"
    },
    {
    "name": "Sri Lanka",
    "dial_code": "+94",
    "code": "LK"
    },
    {
    "name": "Sudan",
    "dial_code": "+249",
    "code": "SD"
    },
    {
    "name": "Suriname",
    "dial_code": "+597",
    "code": "SR"
    },
    {
    "name": "Svalbard and Jan Mayen",
    "dial_code": "+47",
    "code": "SJ"
    },
    {
    "name": "Swaziland",
    "dial_code": "+268",
    "code": "SZ"
    },
    {
    "name": "Sweden",
    "dial_code": "+46",
    "code": "SE"
    },
    {
    "name": "Switzerland",
    "dial_code": "+41",
    "code": "CH"
    },
    {
    "name": "Syrian Arab Republic",
    "dial_code": "+963",
    "code": "SY"
    },
    {
    "name": "Taiwan",
    "dial_code": "+886",
    "code": "TW"
    },
    {
    "name": "Tajikistan",
    "dial_code": "+992",
    "code": "TJ"
    },
    {
    "name": "Tanzania, United Republic of Tanzania",
    "dial_code": "+255",
    "code": "TZ"
    },
    {
    "name": "Thailand",
    "dial_code": "+66",
    "code": "TH"
    },
    {
    "name": "Timor-Leste",
    "dial_code": "+670",
    "code": "TL"
    },
    {
    "name": "Togo",
    "dial_code": "+228",
    "code": "TG"
    },
    {
    "name": "Tokelau",
    "dial_code": "+690",
    "code": "TK"
    },
    {
    "name": "Tonga",
    "dial_code": "+676",
    "code": "TO"
    },
    {
    "name": "Trinidad and Tobago",
    "dial_code": "+1868",
    "code": "TT"
    },
    {
    "name": "Tunisia",
    "dial_code": "+216",
    "code": "TN"
    },
    {
    "name": "Turkey",
    "dial_code": "+90",
    "code": "TR"
    },
    {
    "name": "Turkmenistan",
    "dial_code": "+993",
    "code": "TM"
    },
    {
    "name": "Turks and Caicos Islands",
    "dial_code": "+1649",
    "code": "TC"
    },
    {
    "name": "Tuvalu",
    "dial_code": "+688",
    "code": "TV"
    },
    {
    "name": "Uganda",
    "dial_code": "+256",
    "code": "UG"
    },
    {
    "name": "Ukraine",
    "dial_code": "+380",
    "code": "UA"
    },
    {
    "name": "United Arab Emirates",
    "dial_code": "+971",
    "code": "AE"
    },
    {
    "name": "United Kingdom",
    "dial_code": "+44",
    "code": "GB"
    },
    {
    "name": "United States",
    "dial_code": "+1",
    "code": "US"
    },
    {
    "name": "Uruguay",
    "dial_code": "+598",
    "code": "UY"
    },
    {
    "name": "Uzbekistan",
    "dial_code": "+998",
    "code": "UZ"
    },
    {
    "name": "Vanuatu",
    "dial_code": "+678",
    "code": "VU"
    },
    {
    "name": "Venezuela, Bolivarian Republic of Venezuela",
    "dial_code": "+58",
    "code": "VE"
    },
    {
    "name": "Vietnam",
    "dial_code": "+84",
    "code": "VN"
    },
    {
    "name": "Virgin Islands, British",
    "dial_code": "+1284",
    "code": "VG"
    },
    {
    "name": "Virgin Islands, U.S.",
    "dial_code": "+1340",
    "code": "VI"
    },
    {
    "name": "Wallis and Futuna",
    "dial_code": "+681",
    "code": "WF"
    },
    {
    "name": "Yemen",
    "dial_code": "+967",
    "code": "YE"
    },
    {
    "name": "Zambia",
    "dial_code": "+260",
    "code": "ZM"
    },
    {
    "name": "Zimbabwe",
    "dial_code": "+263",
    "code": "ZW"
    }
    ]